const TEXTS = {
  default: {
    heading: "Sign up and get personalized recommendations.",
    subheading: "Create a free account to discover partnering requests that suit your expertise.",
    bullets: [
      "Get matched to relevant partnering requests",
      "Receive partnering request invitations made for you",
      "Follow organizations you're interested in",
      "Get noticed by R&D leaders and innovators",
    ],
  },
  marketplace: {
    heading: "Explore more opportunities",
    subheading: "Create a free account to access our full selection of opportunities",
    bullets: [
      "Get discovered by industry partners seeking your expertise",
      "Get matched to opportunities that suit your profile",
      "Submit proposals in less than an hour",
      "Receive feedback directly from industry contacts",
    ],
  },
  refineRecommendations: {
    heading: "Sign up and get personalized recommendations.",
    subheading: "Create a free account to discover partnering requests that suit your expertise.",
    bullets: [
      "Get matched to relevant partnering requests",
      "Receive request invitations made for you",
      "Follow organizations you're interested in",
      "Get noticed by industry leaders",
    ],
  },
};

export default TEXTS;
